var _defs, _polyline, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSticla3White(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ba1f1932-1516-4300-99fd-9ba2f65b79dd",
    "data-name": "sticla_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a2e83553-551a-43a6-9a6f-0c404c268b89{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:10px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sticla_3_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a2e83553-551a-43a6-9a6f-0c404c268b89",
    points: "5 5 5 195 95 195 95 5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a2e83553-551a-43a6-9a6f-0c404c268b89",
    x1: 50,
    y1: 195,
    x2: 50,
    y2: 5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticla3White);
export default __webpack_public_path__ + "static/media/sticla_3_white.98d9d72bc93d89455724b9d76f494e69.svg";
export { ForwardRef as ReactComponent };